import { combineReducers } from "@reduxjs/toolkit";
import userSlice from "../slices/authSlice";
import searchSlice from "../slices/customer/searchSlice";

export const allReducers = combineReducers({
  user: userSlice,
  customer: combineReducers({
    searchData: searchSlice, // Properly nested under customer
  }),
});

export type RootState = ReturnType<typeof allReducers>;
